var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUInverse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40.4 50.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e9f6d9;stroke:#4a6a62;stroke-miterlimit:10;stroke-width:0.4px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "U inverse") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "U_Invers\\xE9",
    "data-name": "U Invers\\xE9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0.2 50.2 0.2 0.2 40.2 0.2 40.2 12.2 20.2 12.2 20.2 38.2 40.2 38.2 40.2 50.2 0.2 50.2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUInverse);
export default __webpack_public_path__ + "static/media/U-inverse.537806ff34ff3b8eca9b6ecc5ce52186.svg";
export { ForwardRef as ReactComponent };